module.exports = __webpack_public_path__ + "img/bg-top.e92b5573.webp";